import cn from 'bem-cn';

import { Divider, LikesCounter, SharesCounter, Stack } from '../../UI';
import { BackButton } from '../../BackButton/BackButton';

import { PromptInfoStatisticsProps } from './PromptInfoStatistics.types';
import './PromptInfoStatistics.scss';

const b = cn('prompt-info-statistics');

export const PromptInfoStatistics = (props: PromptInfoStatisticsProps) => {
    const { className, likes = 0, isLiked = false, countersDirection = 'row', onLikeClick, onShareClick } = props;

    return (
        <Stack className={b.mix(className)}>
            <BackButton />
            <LikesCounter direction={countersDirection} likes={likes} isLiked={isLiked} onClick={onLikeClick} />
            <Divider orientation="vertical" />
            <SharesCounter onClick={onShareClick} />
        </Stack>
    );
};
